export { default as Pagination } from './Pagination'
export type { PaginationProps } from './Pagination'
